module.exports = __webpack_public_path__ + "img/title_mobile.a7b72ecf.png";